<template>
  <div>
    <v-card class="mx-auto productCategoryCard" :loading="loading">
      <template v-slot:loader="{ isActive }">
        <v-progress-linear
          :active="isActive"
          color="deep-purple"
          height="4"
          indeterminate
        ></v-progress-linear>
      </template>
      <v-img
        :src="`${productDetails.category_img_path}`"
        height="200px"
        cover
        class="fitProductImage"
      ></v-img>
      <div style="text-align: left">
        <div class="card-title bold">
          {{ categoryExistence.suggestedName || productDetails.category_name }}
        </div>
        <v-card-subtitle style="padding-top: 0px; text-transform: uppercase;">{{
          productDetails.category_tagline
        }}</v-card-subtitle>
      </div>
      <v-divider class="mx-4 mb-1"></v-divider>
      <div class="px-4">
        <v-chip-group>
          <v-chip
            >{{ $t('taxRate') }}:
            <strong style="margin-left: 3px;">
              {{ productDetails.category_tax_rate }} %</strong
            ></v-chip
          >
        </v-chip-group>
        <div class="suggSellingPrice">
          <div style="text-align: left; text-transform: lowercase;">
            {{ $t('step4-mandatory3') }}
          </div>
        </div>
        <v-chip-group>
          <v-chip>{{ productDetails.category_type }}</v-chip>
        </v-chip-group>
        <br />
        <!-- :disabled="$v.$invalid" -->
        <div style="text-align: center;">
          <button
            class="add-btn"
            type="button"
            name="button"
            @click="addProductCategory"
          >
            {{ $t('add') }}
          </button>
        </div>
        <br />
      </div>
    </v-card>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  data() {
    return {
      id: this.product.id,
      loading: false,
      showDetails: false
    }
  },
  validations: {
    product: {
      category: { required }
    }
  },
  mounted() {},
  methods: {
    async addProductCategory() {
      const productCategory = this.createProductCategoryObject()
      this.$store
        .dispatch('productCategory/createProductCategory', productCategory)
        .then(response => {
          this.$emit('change-category', response.insertId)
        })
        .catch(err => {
          console.log(`err = `, err)
          if (err.message === 'INVALID_STRIPE_KEY')
            alert(this.$t('invalidStripeKeys'))
          if (err.message === 'STRIPE_KEY_NOT_AVAILABLE')
            alert(this.$t('completeProfileFirst'))
        })
    },
    createProductCategoryObject() {
      const client = this.$store.state.client.client

      return {
        client: client,
        name:
          this.categoryExistence.suggestedName ||
          this.productDetails.category_name,
        tax_rate: this.productDetails.category_tax_rate,
        hero_tagline: this.productDetails.category_tagline,
        type: this.productDetails.category_type,
        img_path: this.productDetails.category_img_path,
        img_size: this.productDetails.category_img_size,
        img_name: this.productDetails.category_img_name
      }
    }
  },
  props: {
    productDetails: {
      type: Object,
      default: () => {
        return {}
      }
    },
    product: {
      type: Object,
      default: () => {
        return {}
      }
    },
    categoryExistence: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fitProductImage {
  width: 100% !important;
  object-fit: cover !important;
}
.productCategoryCard {
  margin: 20px 10px !important;
}
.pulseContainer {
  background: none !important;
  position: absolute;
  bottom: 80px;
  right: 30px;
}

.card-title {
  width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin-top: 10px;
  margin: auto;
  margin-left: 20px !important;
  font-size: 1.5rem;
}
.bold {
  font-weight: 700 !important;
}
.stock-general {
  display: inline;
}
.description {
  max-height: 200px;
  white-space: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: justify;
  font-size: 0.7rem;
}

.sendInquiryBtn {
  background-color: var(--bg-light) !important;
  border: none;
  color: var(--bright);
  box-shadow: none;
  font-weight: 600;
}

.readMoreBtn {
  background-color: none !important;
  border: none;
  color: var(--bg-light);
  box-shadow: none;
  font-weight: 600;
}

.pricingDetails {
  text-align: left;
  margin-top: 10px;
}

.suggSellingPrice {
  font-size: 0.7rem;
}

.card-img-top {
  height: 100px;
  width: auto;
  margin: auto;
  max-width: 200px !important;
}
.container {
  position: absolute;
  top: 0;
  left: 0%;
  padding-top: 0;
}
.card-body {
  /* flex: 1 1 auto;
    min-height: 1px; */
  padding: 0.25rem 0rem;
}
/* .card-name {
	color: #454655;
}
.card-text {
	color: #454655;
} */

.add-btn {
  background: var(--primaryDark);
  color: var(--bright);
  // padding: 0.3em;
  letter-spacing: 3px;
  border-radius: 5px;
  text-transform: uppercase;
  width: auto;
}

.add-btn2 {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 0.5em;
  letter-spacing: 3px;
  width: auto;
  border-radius: 10px;
  margin: auto;
}
.inquiry-btn {
  color: var(--bg-light) !important;
  border: 1px solid var(--bg-light);
  background: none;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: 1em;
  padding: 5px 10px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
  margin: auto;
  width: 100%;
  margin-bottom: 10px;
  margin-top: 10px;
}

.inquiry-btn:hover {
  background: var(--primaryDark);
  color: var(--bright) !important;
}
.icon {
  font-size: 1.3em;
  padding: 1px;
  float: right;
  cursor: pointer;
}

@keyframes pulse {
  0% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(251, 115, 119, 0.7), 0 0 0 0 rgba(201, 92, 95, 0.7);
  }
  40% {
    transform: scale(1);
    box-shadow: 0 0 0 40px rgba(251, 115, 119, 0),
      0 0 0 0 rgba(201, 92, 95, 0.7);
  }
  80% {
    transform: scale(1);
    box-shadow: 0 0 0 40px rgba(251, 115, 119, 0),
      0 0 0 20px rgba(201, 92, 95, 0);
  }
  100% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(251, 115, 119, 0.7),
      0 0 0 20px rgba(201, 92, 95, 0);
  }
}

div[class^='pulse'] {
  background: var(--primaryDark);
  border-radius: 50%;
  color: white;
  cursor: pointer;
  height: auto;
  margin: auto;
  padding: 1.2em;
  text-align: center;
  width: 60px;
}

.pulse:active {
  animation: pulse 0.25s infinite ease-out;
}
.pulse:hover {
  background: #c95c5f;
}

.add-btn {
  background: var(--primaryDark);
  border-radius: 5px;
  color: var(--bright);
  padding: 0.3em;
  letter-spacing: 3px;
  width: 80%;
}

@media only screen and (max-device-width: 1100px) {
  .productCard {
    height: auto !important;
  }
}

@media only screen and (min-device-width: 1100px) {
  .productCard {
    width: 344px !important;
  }
}

@media only screen and (min-device-width: 500px) {
  .card-title {
    margin-top: 10px;
    line-height: 30px;
  }
  .productCard:hover {
    background: rgba(128, 128, 128, 0.1) !important;
    box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px,
      rgba(0, 0, 0, 0.117647) 0px 1px 4px;
    margin: 10px !important;
    transform: scale(1.03);
  }
}

@media only screen and (max-device-width: 500px) {
  .productCard {
    margin: auto;
  }
  .card-title {
    margin-top: 8px;
    line-height: 25px;
  }
}
@media only screen and (min-device-width: 300px) and (max-device-width: 359px) {
  .card-title {
    width: 240px;
    font-size: 1.2rem;
  }
  .sendInquiryBtn {
    font-size: 0.7rem !important;
  }
  .readMoreBtn {
    font-size: 0.7rem !important;
  }
  .pulseContainer {
    bottom: 30px !important;
    right: 10px !important;
  }
  .pulse {
    padding: 10px !important;
    width: 40px !important;
  }
}

@media only screen and (min-device-width: 360px) and (max-device-width: 379px) {
  .card-title {
    width: 270px;
  }
}
@media only screen and (min-device-width: 381px) {
  .card-title {
    width: 300px;
  }
}
// @media only screen and (min-device-width: 400px) {
// 	.card-title {
// 	width: 305px;
// }
// }
</style>
